"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LanguageToggle = void 0;
const react_1 = __importStar(require("react"));
const theme_1 = __importDefault(require("../styles/theme"));
const utils_1 = require("../lib/utils");
const uplift_icons_1 = require("./uplift-icons");
const styled_div_1 = require("./styled-div");
const button_1 = require("./button");
const text_1 = require("./text");
const LanguageToggle = ({ className, id, style, languages, locale, onSelect = utils_1.noop, size = 14, displayLocale = true, }) => {
    const [currentLocale, setCurrentLocale] = react_1.useState(locale);
    return (react_1.default.createElement(styled_div_1.StyledDiv, { className: className, id: id, style: Object.assign({ alignItems: 'center', display: 'flex' }, style), "data-testid": "language-toggle" },
        react_1.default.createElement(uplift_icons_1.Globe, { size: size }),
        Object.keys(languages).map((key, index) => {
            const selectedStyle = currentLocale === key ? { textDecoration: 'underline' } : {};
            return (react_1.default.createElement(react_1.default.Fragment, { key: key },
                react_1.default.createElement(button_1.Button, { inline: true, link: true, style: Object.assign({ color: theme_1.default.colors.textLink, padding: '0px 4px', fontSize: `${size}px`, fontWeight: theme_1.default.font.weight.normal, lineHeight: 1 }, selectedStyle), onClick: () => {
                        onSelect(key, languages[key]);
                        setCurrentLocale(key);
                    } }, displayLocale ? key.toUpperCase() : languages[key]),
                index < Object.keys(languages).length - 1 && (react_1.default.createElement(text_1.Text, { color: theme_1.default.colors.textLink, style: { fontSize: `${size}px` } }, "|"))));
        })));
};
exports.LanguageToggle = LanguageToggle;
exports.default = exports.LanguageToggle;
